import { render, staticRenderFns } from "./digitalServices.vue?vue&type=template&id=0e568d9d&scoped=true"
import script from "./digitalServices.vue?vue&type=script&lang=js"
export * from "./digitalServices.vue?vue&type=script&lang=js"
import style0 from "./digitalServices.vue?vue&type=style&index=0&id=0e568d9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e568d9d",
  null
  
)

export default component.exports